export enum AnalyticsEvent {
  MAP_LOAD = "map_load",
  MAP_FEATURE_OPEN = "map_feature_open",
  MAP_LEVEL_CHANGE = "map_level_change",
  MAP_LAYER_CHANGE = "map_layer_change",
  ROUTE_REQUEST = "route_request",
  SEARCH_QUERY_SEND = "search_query_send",
  SEARCH_FEATURE_OPEN = "search_feature_open",
  ATTRIBUTION_OPEN = "attribution_open",
  SHARE_OPEN = "share_open",
  LEVEL_SELECTOR_TOUCH = "level_selector_touch",
  LAYER_SELECTOR_TOUCH = "layer_selector_touch",
  NORTH_ORIENTATION_ON = "north_orientation_on",
  NORTH_ORIENTATION_OFF = "north_orientation_off",
  SHOW_POSITION_ON = "show_position_on",
  SHOW_POSITION_OFF = "show_position_off",
  BOOKMARK_SELECT = "bookmark_select",
  LANGUAGE_CHANGE = "language_change",
  PANORAMA_OPEN = "panorama_open",
  ROUTE_FAIL = "route_fail",
  ROUTE_SHOWN = "route_shown",
}

export interface MapLoadEvent {
  event_type: AnalyticsEvent.MAP_LOAD;
  event_data: {
    type: "embedded" | "native";
    source?: string;
    device_height: number;
    device_width: number;
  };
}

interface MapFeatureOpenEvent {
  event_type: AnalyticsEvent.MAP_FEATURE_OPEN;
  event_data: {
    lm_id: string;
    name: string;
  };
}

interface MapLevelChangeEvent {
  event_type: AnalyticsEvent.MAP_LEVEL_CHANGE;
  event_data: {
    // TODO: NB. building_from / _to currently have no DB values
    // building_from: string;
    from_floor: string;
    // building_to: string;
    to_floor: string;
  };
}

interface MapLayerChangeEvent {
  event_type: AnalyticsEvent.MAP_LAYER_CHANGE;
  event_data: {
    from: string;
    to: string;
  };
}

interface RouteEvent {
  event_type:
    | AnalyticsEvent.ROUTE_REQUEST
    | AnalyticsEvent.ROUTE_FAIL
    | AnalyticsEvent.ROUTE_SHOWN;
  event_data:
    | {
        to_lm_id: string;
        from_latitude: number;
        from_longitude: number;
        from_floor?: string;
        step_free: boolean;
      }
    | {
        to_lm_id: string;
        from_lm_id: string;
        step_free: boolean;
      }
    | {
        to_latitude: number;
        to_longitude: number;
        to_floor?: string;
        from_lm_id: string;
        step_free: boolean;
      }
    | {
        to_latitude: number;
        to_longitude: number;
        to_floor?: string;
        from_latitude: number;
        from_longitude: number;
        from_floor?: string;
        step_free: boolean;
      };
}

interface SearchQuerySendEvent {
  event_type: AnalyticsEvent.SEARCH_QUERY_SEND;
  event_data: {
    query: string;
    quick_search: boolean;
    quick_search_id: number | null;
  };
}

interface SearchFeatureOpenEvent {
  event_type: AnalyticsEvent.SEARCH_FEATURE_OPEN;
  event_data: {
    lm_id: string;
    name: string;
  };
}

interface AttributionOpenEvent {
  event_type: AnalyticsEvent.ATTRIBUTION_OPEN;
}

interface FeatureShareOpenEventData {
  type: "feature";
  name: string;
  lm_id: string;
  share_url: string;
}

interface RouteShareOpenEventData {
  type: "route";
  from_latitude?: number;
  from_longitude?: number;
  from_floor?: string;
  to_latitude?: number;
  to_longitude?: number;
  to_floor?: string;
  from_lm_id?: string;
  from_name?: string | null;
  to_lm_id?: string;
  to_name?: string | null;
  share_url: string;
}

interface ShareOpenEvent {
  event_type: AnalyticsEvent.SHARE_OPEN;
  event_data: FeatureShareOpenEventData | RouteShareOpenEventData;
}

interface LevelSelectorTouchEvent {
  event_type: AnalyticsEvent.LEVEL_SELECTOR_TOUCH;
}

interface LayerSelectorTouchEvent {
  event_type: AnalyticsEvent.LAYER_SELECTOR_TOUCH;
}

interface NorthOrientationOnEvent {
  event_type: AnalyticsEvent.NORTH_ORIENTATION_ON;
}

interface NorthOrientationOffEvent {
  event_type: AnalyticsEvent.NORTH_ORIENTATION_OFF;
}

interface ShowPositionOnEvent {
  event_type: AnalyticsEvent.SHOW_POSITION_ON;
}

interface ShowPositionOffEvent {
  event_type: AnalyticsEvent.SHOW_POSITION_OFF;
}

interface BookmarkSelectEvent {
  event_type: AnalyticsEvent.BOOKMARK_SELECT;
  event_data: string;
}

interface LanugageChangeEvent {
  event_type: AnalyticsEvent.LANGUAGE_CHANGE;
  event_data: string;
}

interface PanoramaOpenEvent {
  event_type: AnalyticsEvent.PANORAMA_OPEN;
}

export type AnalyticsEvents =
  | MapLoadEvent
  | MapFeatureOpenEvent
  | MapLevelChangeEvent
  | MapLayerChangeEvent
  | RouteEvent
  | SearchQuerySendEvent
  | SearchFeatureOpenEvent
  | AttributionOpenEvent
  | ShareOpenEvent
  | LevelSelectorTouchEvent
  | LayerSelectorTouchEvent
  | NorthOrientationOnEvent
  | NorthOrientationOffEvent
  | ShowPositionOnEvent
  | ShowPositionOffEvent
  | LanugageChangeEvent
  | PanoramaOpenEvent
  | BookmarkSelectEvent;
